// New UI only (docs/ui_redesign/18-ux-review.md, R1 and R3). In Classic a lookup's Close applies the ticked row, and with
// nothing ticked it clears the field, so Close can't be the way out. The new UI adds Cancel (also Escape and ✕): the
// lookup passes LOOKUP_CANCEL to its onClose, and the screen's close handler only closes the lookup. Classic never
// sends it, so Classic's handlers behave as before.
export const LOOKUP_CANCEL = Object.freeze({ apw2LookupCancel: true });

export const isLookupCancel = v => !!v && (v.apw2LookupCancel === true
	|| (Array.isArray(v) && v.length === 1 && !!v[0] && v[0].apw2LookupCancel === true));

// A single-choice lookup's dialog, for the popup helper (search box focused, row click ticks, radio-style ticks).
export const lookupDialogProps = newUi => (newUi ? { PaperProps: { 'data-apw2-lookup': 'single' } } : {});
